// src/plugins/axios.js
import axios from 'axios';

// 创建一个Axios实例
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 你的API基础URL
  timeout: 10000, // 请求超时时间
  headers: { 'Content-Type': 'application/json' } // 默认请求头
});

// 添加请求拦截器（可选）
axiosInstance.interceptors.request.use(config => {
  // 在发送请求之前做些什么，比如添加认证token
  // config.headers['Authorization'] = `Bearer ${token}`;
  return config;
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器（可选）
axiosInstance.interceptors.response.use(response => {
  // 对响应数据做点什么
  return response;
}, error => {
  // 对响应错误做点什么
  return Promise.reject(error);
});

// 导出Axios实例
export default axiosInstance;